import React from 'react';
import { useTranslation } from 'react-i18next';
import { scrollWithOffset } from '../../../Common/Utils/scroller';
import { Path } from '../../../Routing';
import { HashLinkPathsIds } from '../../../Routing/HashLinkPathIds';
import { Header, StyledHashLink } from './sharedStyles';

const ProductLinks: React.FC = () => {
  const { t } = useTranslation();

  return (
    <>
      <Header>{t('footer.ourProducts')}</Header>
      <StyledHashLink
        to={Path.ProductExtension}
        scroll={scrollWithOffset}
        elementId={HashLinkPathsIds.Root}
        smooth
      >
        {t('footer.mobileBrowserExtension')}
      </StyledHashLink>
      <StyledHashLink
        to={Path.ProductDesktop}
        scroll={scrollWithOffset}
        elementId={HashLinkPathsIds.Root}
        smooth
      >
        {t('footer.desktopExtension')}
      </StyledHashLink>
      <StyledHashLink
        to={Path.ProductApi}
        scroll={scrollWithOffset}
        elementId={HashLinkPathsIds.Root}
        smooth
      >
        {t('footer.dealsAPI')}
      </StyledHashLink>
    </>
  );
};

export default ProductLinks;
